module.exports = __webpack_public_path__ + "img/prize-01.d7b32082.png";